import React, { Component } from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import Button from "../../components/Button";


class VPractice extends Component {


render() {
    return (
	<div> 
		
		<InstructionContainer>
			<h1> Practice </h1>	
			<P> Following are three tasks to help you practice.
			<br/> You are advised to take at least one practice task 
			before taking the qualification test.
			<br/> Select a task and click on its button. 
			<br/><br/><Link target="_blank" to="/practice1">Practice #1</Link>
			<br/><Link target="_blank" to="/practice2">Practice #2</Link>
			<br/><Link target="_blank" to="/practice3">Practice #3</Link>
			<br/>
			
			<br/> If needed, click the INTRODUCTION button to go through the task description again.
			<br/> When you feel ready to take the test terminate this session 
			and go back to the Amazon MTurk website.
			</P>
		</InstructionContainer>		
		
		
		<StyledButton primary>
			<RedirectLink target="_blank" to="/Intro">Introduction</RedirectLink>
		</StyledButton>	
		
		
		
		
	</div>
	);
	}
}
export default VPractice;



// layout
const InstructionContainer = styled.div`
background: lightblue;
margin: 1em;
width: 90vw;


 ${props => props.primary && css `  //that's for displaying app component
    background: #e0e0e0;
	max-width: 60vw;
	margin: auto;
  `}

`;
 
const P = styled.p`
text-align: left;
font-size: large;

	${props => props.primary && css `  //that's for displaying app component
    font-size: small;
	`}

`;


const StyledButton = styled(Button)`
  width: 18%;
  margin-right: 10%;
  float: left;
  
  ${props => props.primary && css `  //that's for displaying app component
    background: orange;
	font-size: medium;
	`}
  
`;

const RedirectLink = styled(Link)`
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0);
  padding: 20px 10px;
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  transition: all 300ms;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;
